import React from 'react';
import { CreditCardIcon, FileTextIcon, GlobeIcon, LockIcon, ShieldCheckIcon, StarIcon, ZapIcon } from 'lucide-react';
import { miniTestimonials } from '../data/content';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
const badges = [{
  icon: FileTextIcon,
  label: '100% Digital'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}];
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días sin preguntas'
}, {
  icon: LockIcon,
  label: 'Pago 100% seguro'
}];
const stats = [{
  value: "+500",
  label: "personas confían en NATURIA"
}, {
  value: '6 tomos + 5 bonos',
  label: 'completamente listos'
}, {
  value: "4.8/5",
  label: 'calificación promedio'
}];
function Stars() {
  return <span className="flex items-center gap-0.5" aria-label="5 de 5 estrellas" data-id="element-103" data-mp="nbey3ftkqix8">
      {[0, 1, 2, 3, 3].map(index => <StarIcon key={index} className="h-3.5 w-3.5 fill-mint-500 text-mint-500" aria-hidden="true" data-id="element-104" data-mp="3d33d6tuq0lin" />)}
    </span>;
}
export function Hero() {
  return <header className="relative overflow-hidden bg-mint-50" data-id="element-105" data-mp="3j8selyn99fos">
      <div className="mx-auto max-w-6xl px-6 pb-16 pt-14 sm:pt-20" data-id="element-106" data-mp="3j9alrqbghebh">
        <div className="grid items-center gap-14 lg:grid-cols-[minmax(0,1.05fr)_minmax(0,0.95fr)] lg:gap-16" data-id="element-107" data-mp="3o6kdjcmbi22h">
          <div data-id="element-108" data-mp="399tej4gk2sde">
            <Reveal data-id="element-109" data-mp="39a32ynlycrgz">
              <p className="text-sm font-semibold uppercase tracking-[0.18em] text-mint-700" data-id="element-110" data-mp="3e9frdcsh26lo">
                Naturia · MegaPack Salud Plena
              </p>
              <h1 className="mt-5 font-display text-4xl leading-[1.05] text-ink sm:text-5xl lg:text-6xl" data-id="element-111" data-mp="30ggdtgc92mgr">
                Tu intestino inflamado,
                <span className="block text-mint-700" data-id="element-112" data-mp="2qjv4wjx40r7n">Un protocolo innovador que lo resuelve en 15 días.</span>
              </h1>
              <p className="mt-6 max-w-xl text-lg leading-relaxed text-ink-soft sm:text-xl" data-id="element-113" data-mp="2vi50uwqnrvub">
                Transformá tu inflamación sin dietas restrictivas ni confusión sobre qué comer. Es simple y fácil de implementar. No es necesario saber cocinar! 
              </p>
            </Reveal>

            <Reveal delay={0.06} data-id="element-114" data-mp="s2b7hx6yyh4m">
              <ul className="mt-8 flex flex-wrap items-center gap-2.5" data-id="element-115" data-mp="s3ckw8bgjfpi">
                {badges.map(badge => <li key={badge.label} className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-white px-3.5 py-2 text-sm font-medium text-ink-soft ring-1 ring-inset ring-mint-200" data-id="element-116" data-mp="n9qjxdenp09j">
                    <badge.icon className="h-4 w-4 text-mint-600" aria-hidden="true" data-id="element-117" data-mp="deq4e3a3ghwp" />
                    {badge.label}
                  </li>)}
              </ul>

              <div className="mt-8" data-id="element-118" data-mp="161jal16969e3">
                <CtaButton data-id="element-119" data-mp="162m0p6vr47sy">Quiero el Megapack</CtaButton>
              </div>

              <ul className="mt-7 flex flex-wrap gap-x-6 gap-y-3" data-id="element-120" data-mp="111ogypv3f5pc">
                {trust.map(item => <li key={item.label} className="inline-flex items-center gap-2 whitespace-nowrap text-sm text-ink-muted" data-id="element-121" data-mp="x1w789tyqtie">
                    <item.icon className="h-4 w-4 text-mint-600" aria-hidden="true" data-id="element-122" data-mp="3luiaiu6w15my" />
                    {item.label}
                  </li>)}
              </ul>
            </Reveal>
          </div>

          <div data-id="element-123" data-mp="1xam9t2xwyd4q">
            <img src="https://cdn.magicpatterns.com/uploads/4ASVY3GgLjwPr6cLHNRnfP/e45b6f76-3e8d-430f-ac26-e60c5700a057.webp" alt="Los 6 tomos del MegaPack Salud Plena en formato digital, vistos en libros y tablet" className="w-full rounded-3xl bg-mint-100 object-cover shadow-lift" width={1200} height={900} loading="eager" decoding="async" fetchPriority="high" style={{
            objectFit: "cover",
            width: "327px",
            height: "502px"
          }} data-id="element-124" data-mp="1xb5p0bw6inf2" />
          </div>
        </div>

        <Reveal delay={0.05} data-id="element-125" data-mp="2l102mvobog0d">
          <dl className="mt-16 grid gap-px overflow-hidden rounded-2xl bg-mint-200 sm:grid-cols-3" data-id="element-126" data-mp="2p0qp4n6tg9z3">
            {stats.map(stat => <div key={stat.value} className="bg-white px-6 py-6" data-id="element-127" data-mp="2tztw4d6cwq9p">
                <dt className="font-display text-2xl text-ink" data-id="element-128" data-mp="umhe6cmywlov">{stat.value}</dt>
                <dd className="mt-1 text-sm text-ink-muted" data-id="element-129" data-mp="uokepqlqxx7u">{stat.label}</dd>
              </div>)}
          </dl>
        </Reveal>

        <Reveal delay={0.05} data-id="element-130" data-mp="4b47zvkw08ki">
          <ul className="mt-10 grid gap-6 sm:grid-cols-3" data-id="element-131" data-mp="4acohj4ke1al">
            {miniTestimonials.map(item => <li key={item.initials} className="flex h-full flex-col border-t border-mint-200 pt-5" data-id="element-132" data-mp="3vigo07a1afyu">
                <Stars data-id="element-133" data-mp="e8imhpn92na6" />
                <p className="mt-3 text-[15px] leading-relaxed text-ink" data-id="element-134" data-mp="e91vgguxa1c2">
                  “{item.quote}”
                </p>
                <p className="mt-auto pt-4 text-sm text-ink-muted" data-id="element-135" data-mp="98mj9smdmzvo">
                  {item.name} · {item.location}
                </p>
              </li>)}
          </ul>
        </Reveal>

        <Reveal delay={0.05} data-id="element-136" data-mp="3cp318pgh5fub">
          <p className="mt-8 text-sm text-ink-soft" data-id="element-137" data-mp="3rftttzpw4iyh">
            ¿Querés aparecer en los testimonios?{' '}
            <a href="mailto:soporte.int@naturiasalud.com?subject=Quiero%20contar%20mi%20experiencia%20con%20el%20MegaPack" className="font-semibold text-mint-700 underline underline-offset-4 transition-colors duration-150 ease-out hover:text-mint-800" data-id="element-138" data-mp="3motxavkoo2wi">
              Mandanos un email
            </a>{' '}
            y contanos tu experiencia.
          </p>
        </Reveal>
      </div>
    </header>;
}